export default __webpack_public_path__ + "static/pools_network-ed97987c945f68a5d1137125c1d1da30.png";